export class Camera {
  constructor(difference) {
    this.styleId = 1
    this.width = 400
    this.height = 400
    this.top = 20
    this.left = 20
    this.innerElement = "cxCamera"
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
